import React from 'react'
import PropTypes from 'prop-types'

import useRect from '../hooks/useRect'
import Text from './Text.jsx'
import { FOOTER_HEIGHT } from './constants'

const BRAND_COLOR = '#10441B'

const padLeadingZeros = (num, size) => {
  let s = num + ''
  while (s.length < size) s = '0' + s
  return s
}

const Footer = (props) => {
  const { page, theme, hideIcon } = props
  const [Rect, rect] = useRect()

  const colors = {
    bk: theme.background === 'light' ? 'transparent' : BRAND_COLOR,
    icon: theme.icon === 'dark' ? BRAND_COLOR : '#ffffff',
    page: theme.page === 'light' ? '#ffffff' : BRAND_COLOR,
  }

  return (
    <>
      <Rect />
      <svg x={0} width={rect.width} y={rect.height - FOOTER_HEIGHT} height={FOOTER_HEIGHT}>
        <rect x={0} y={0} width={rect.width} height={FOOTER_HEIGHT} fill={colors.bk} />
        {/* ShareThis icon */}
        {!hideIcon && (
          <svg
            width="32"
            height="32"
            x={32}
            y={16}
            viewBox="0 0 16 16"
            fill={colors.icon}
            data-custom-render="ai-inline-svg"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.753 10.8824C12.3836 10.8824 12.0414 10.9907 11.7488 11.1705C11.6476 11.2315 11.5212 11.2631 11.394 11.2631C11.2756 11.2631 11.1598 11.2303 11.0632 11.1767L5.55295 8.2471C5.45765 8.20517 5.39131 8.10927 5.39131 7.99967C5.39131 7.88966 5.45849 7.79377 5.55379 7.75142L11.0632 4.82222C11.1598 4.76909 11.2756 4.73588 11.394 4.73588C11.5212 4.73588 11.6476 4.76784 11.7488 4.82887C12.0414 5.00821 12.3836 5.11656 12.753 5.11656C13.8097 5.11656 14.6666 4.26968 14.6666 3.22478C14.6666 2.17988 13.8097 1.33301 12.753 1.33301C11.7656 1.33301 10.9624 2.07527 10.86 3.0251C10.8386 3.25882 10.6807 3.4556 10.478 3.55565L5.03614 6.44831C4.9358 6.50809 4.81405 6.54172 4.6881 6.54172C4.53948 6.54172 4.4001 6.4973 4.28926 6.41635C3.98867 6.22248 3.63181 6.10749 3.24641 6.10749C2.1897 6.10749 1.33325 6.95478 1.33325 7.99967C1.33325 9.04457 2.1897 9.89145 3.24641 9.89145C3.63181 9.89145 3.98867 9.77687 4.28926 9.583C4.4001 9.50164 4.53948 9.45763 4.6881 9.45763C4.81405 9.45763 4.9358 9.49084 5.03614 9.55062L10.478 12.4437C10.6803 12.5433 10.8386 12.7405 10.86 12.9742C10.9624 13.9237 11.7656 14.6663 12.753 14.6663C13.8097 14.6663 14.6666 13.819 14.6666 12.7742C14.6666 11.7293 13.8097 10.8824 12.753 10.8824Z"
            />
          </svg>
        )}
        {typeof page !== 'undefined' && (
          <Text
            value={padLeadingZeros(page, 2)}
            fontSize={24}
            fontWeight={600}
            fill={colors.page}
            width={32}
            x={rect.width - 28 - 32}
            y={16 + 4} // '4' is visual adjust
          />
        )}
      </svg>
    </>
  )
}

Footer.propTypes = {
  page: PropTypes.number,
  theme: PropTypes.shape({
    background: PropTypes.oneOf(['light', 'dark']),
    icon: PropTypes.oneOf(['light', 'dark']),
    page: PropTypes.oneOf(['light', 'dark']),
  }),
  hideIcon: PropTypes.bool,
}

Footer.defaultProps = {
  page: 0,
  theme: {},
  hideIcon: false,
}

export default Footer
